import { useEffect, useRef } from 'react';
import useSlides from '@klv/hooks/useSlides';
import { SlideIndicators } from '@klv/molecules/slide-indicators';
import { gtmBasicEvent } from '@klv/shared/utils/google-tag-manager';

import useCarouselCardPosition from '../../../hooks/use-carousel-card-position';
import AudienceCard from '../../molecules/audience-card';

import * as s from './styles';
import type { IAudience, IAudienceCards } from './types';

const Audience = ({ headline, audienceCards }: IAudience) => {
  const initialRender = useRef(true);
  const { slides, setThisSlide, swipeable, slideState, swipe } = useSlides(audienceCards, ['left', 'right']);
  const { windowWidth, cardWidth, resizing } = useCarouselCardPosition('[data-audience-card]');
  useEffect( () => {
    if (initialRender.current === true) {
      initialRender.current = false;
    } else {
      const currentSlide = slideState.current + 1;
      gtmBasicEvent({ action: `card ${currentSlide}`, category: 'carousel scroll', label: 'audience', non_interaction_flag: false });
    } 
  }, [slideState, initialRender]);
  return (
  <s.StyledAudience>
    <s.AudienceGrid>
      <s.Headline
        colorVariant='light'
        forwardedAs= 'h2'
        variant='h2'
        dangerouslySetInnerHTML={{ __html: headline }}
      />
    </s.AudienceGrid>
    <s.AudienceContainer {...swipeable}>
      <s.StyledInnerGrid>
          <s.Audience
            $current={slideState.current} 
            $cardWidth={cardWidth}
            $windowWidth={windowWidth}
            $resizing={resizing}
          >
            {slides.map((row: IAudienceCards, rowIndex: number) => (
              <AudienceCard
                {...row.audienceCard}
                $current={slideState.current === rowIndex} 
                setThisSlide={setThisSlide} 
                key={rowIndex} 
                $index={rowIndex} 
                $activeIndex={slideState.current} 
                swipe={swipe}
              />
            ))}
        </s.Audience>
      </s.StyledInnerGrid>
    </s.AudienceContainer>
    <SlideIndicators
      backgroundColor='dark'
      slides={Array.from(Array(slides.length).keys())}
      setThisSlide={setThisSlide}
      currentSlide={slideState.current}
    />
  </s.StyledAudience>
  );
};

export default Audience;
